import { render } from "./BaseConfirmDialog.vue?vue&type=template&id=494064bf"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__